import {WIZARD_GROUP_TYPES} from "../../WizardSetup/WizardItem/wizardItemInterface";

export const getWizardsOptions = (wizardList) => {
  return wizardList.map(wizard => {
    if (!wizard.uniqueHashId) {
      alert("Wizard error please resave the wizards");
    }
    return getWizardOption(wizard)
  });
}

export const getWizardOption = (wizard) => {
  return {
    text: wizard.name,
    value: wizard.uniqueHashId || wizard.id,
    forWizardId: wizard.id,
    forWizardHashId: wizard.uniqueHashId,
    forWizardName: wizard.name,
  }
}

export const getWizardGroupsOptions = (wizard) => {
  if (!wizard) {
    return []
  }
  return (wizard.wizardGroups || []).map(wizardGroup => {
    return getWizardGroupOption(wizardGroup)
  });
}

export const getWizardGroupOption = (wizardGroup) => {
  const forWizardGroupTitle = wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom
    ? wizardGroup.productCartTitle || wizardGroup.title
    : wizardGroup.customDisplayName || wizardGroup.title;
  return {
    text: wizardGroup.id + ". " + (forWizardGroupTitle || wizardGroup.groupName),
    value: wizardGroup.id,
    forWizardGroupId: wizardGroup.id,
    forWizardGroupTitle,
    forWizardGroupName: wizardGroup.groupName,
  }
}
